import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title is-4"
}
const _hoisted_2 = {
  key: 1,
  class: "title is-4"
}
const _hoisted_3 = { class: "columns mt-6 is-multiline" }
const _hoisted_4 = {
  key: 0,
  class: "column is-6"
}
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Application id *", -1)
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "column is-6" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Description", -1)
const _hoisted_11 = { class: "control" }
const _hoisted_12 = { class: "column is-6" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "CCMS Account", -1)
const _hoisted_15 = { class: "select is-fullwidth" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Not required", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "required" }, "Required", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "suggested" }, "Suggested", -1)
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "column is-6" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Type *", -1)
const _hoisted_23 = { class: "select is-fullwidth" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "BACKEND" }, "Backend", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "FRONTEND" }, "Frontend", -1)
const _hoisted_26 = { class: "column is-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Application Color *", -1)
const _hoisted_28 = { class: "columns is-vcentered" }
const _hoisted_29 = { class: "column" }
const _hoisted_30 = { class: "control" }
const _hoisted_31 = { class: "column is-12" }
const _hoisted_32 = { class: "field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Default Redirection URL *", -1)
const _hoisted_34 = { class: "control" }
const _hoisted_35 = { class: "column is-12" }
const _hoisted_36 = { class: "field" }
const _hoisted_37 = { class: "label" }
const _hoisted_38 = { class: "control" }
const _hoisted_39 = { class: "columns account-form-group is-mobile mt-5 is-aligned-flex-end" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1)
const _hoisted_41 = { class: "column is-narrow" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "clear", -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "column is-narrow" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "arrow_forward", -1)
const _hoisted_46 = [
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.newApp)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "New Application"))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, "Edit Information")),
    _createVNode(_component_Form, {
      id: "applicationForm",
      name: "applicationForm",
      onSubmit: _ctx.editApplicationData
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.newApp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.formData.id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.id) = $event)),
                      name: "applicationId",
                      id: "applicationId",
                      class: "input",
                      type: "text",
                      placeholder: "Application id",
                      rules: "required|uuid"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "applicationId",
                      "data-test": "applicationId",
                      class: "has-text-danger is-tp-input-error"
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.formData.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.description) = $event)),
                  name: "description",
                  id: "description",
                  class: "input",
                  type: "text",
                  placeholder: "Description",
                  ref: "givenName",
                  rules: "required"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "description",
                  "data-test": "description",
                  class: "has-text-danger is-tp-input-error"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.ccmsOptions) = $event)),
                  ref: "ccmsOptions",
                  name: "ccmsOptions",
                  id: "ccmsOptions"
                }, _hoisted_19, 512), [
                  [_vModelSelect, _ctx.formData.ccmsOptions]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.formData.clientType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.clientType) = $event)),
                  name: "client",
                  id: "client",
                  ref: "clientType",
                  rules: "required",
                  as: "select"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _hoisted_25
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "client",
                  "data-test": "client",
                  class: "has-text-danger is-tp-input-error"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.formData.hexColor,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.hexColor) = $event)),
                    name: "applicationColor",
                    id: "applicationColor",
                    class: "input",
                    type: "color",
                    placeholder: "#000000",
                    rules: {regex: /#(?:[a-fA-F\d]{3}){1,2}/}
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "applicationColor",
                    "data-test": "applicationColor",
                    class: "has-text-danger is-tp-input-error"
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.formData.defaultRedirect,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.defaultRedirect) = $event)),
                  name: "redirectURL",
                  id: "redirectURL",
                  rules: "required|url",
                  class: "input",
                  type: "text",
                  placeholder: "Redirect URL",
                  ref: "defaultRedirect"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "redirectURL",
                  "data-test": "redirectURL",
                  class: "has-text-danger is-tp-input-error"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, "Secret" + _toDisplayString(_ctx.newApp ? ' *' : ''), 1),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.formData.secret,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.secret) = $event)),
                  name: "secret",
                  id: "secret",
                  rules: {required: _ctx.newApp},
                  class: "textarea",
                  placeholder: "Secret",
                  rows: "2",
                  as: "textarea"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_ErrorMessage, {
                  name: "secret",
                  "data-test": "secret",
                  class: "has-text-danger is-tp-input-error"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              class: "button has-background-grey-lighter pl-6",
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
              "data-test": "button-back"
            }, _hoisted_43)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-primary pl-6", { 'is-loading': _ctx.loading }]),
              type: "submit",
              "data-test": "button-submit"
            }, _hoisted_46, 2)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}